import { Component, ViewChild, OnInit } from '@angular/core';
import { NgbDropdown, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgFor } from '@angular/common';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { APP_LANGS } from '../../constants/Values';
import { Language } from '../../../../views/layout/navbar/Langauge';
import { ChangeModeLangService } from '../../services/change-mode-lang.service';

@Component({
  selector: 'app-switch-language',
  standalone: true,
  imports: [NgbDropdownModule, NgFor],
  templateUrl: './switch-language.component.html',
  styleUrl: './switch-language.component.scss',
})
export class SwitchLanguageComponent implements OnInit {
  @ViewChild('languageRef', { static: true }) languageRefDrop?: NgbDropdown;

  languages: Language[] = APP_LANGS;
  enable_multiple_lang: boolean = false;
  primary_lang: string = 'en';
  selectedLang: Language = APP_LANGS[0];
  onThemeChange: Subject<any> = new Subject<any>();

  constructor(
    public translate: TranslateService,
    public changeModeLang: ChangeModeLangService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const storedLang = localStorage.getItem('lang');
    const currentLang = storedLang || this.translate.getDefaultLang() || 'en';

    this.translate.use(currentLang);
    const matchedLang = this.languages.find((l) => l.abbr === currentLang);
    if (matchedLang) {
      this.selectedLang = matchedLang;
    }
  }

  changeCurrentLang(lang: Language, render: boolean = true): void {
    this.selectedLang = lang;
    this.translate.use(lang.abbr);
    localStorage.setItem('lang', lang.abbr);

    // Notify theme/layout about direction (LTR/RTL)
    this.changeModeLang.onThemeChange.next({ dir: lang.dir, lang: lang.abbr });
    document.documentElement.dir = lang.dir;

    // Optional rerender logic
    if (render) {
      const url = this.router.url.split('?')[0];
      this.router.navigateByUrl('/auth', { skipLocationChange: true }).then(() => {
        this.router.navigate([url]);
      });
    }
  }
}
